// import { PayrollInsurableEarningsList } from "components/PayrollInsurableEarnings";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PayrollInsurableEarningList } from "../../components/PayrollInsurableEarningList/PayrollInsurableEarningList";

export interface IPayrollInsurableEarningsListPage {}

export const PayrollInsurableEarningsListPage: FC<
	IPayrollInsurableEarningsListPage
> = (props: IPayrollInsurableEarningsListPage) => {
	return (
		<AuthenticatedLayout
			pageTitle="Payroll Insurable Earnings"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<PayrollInsurableEarningList />}
		/>
	);
};
